var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"data-test-id":"close-ticket","pill":"","size":"sm","variant":"danger"},on:{"click":_vm.concludeTicket}},[_vm._v("\n    Conclure\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }